module.exports = __webpack_public_path__ + "img/bg-system-update.dbe73d32.png";